<div class="timeline-entry-icon">
    <div class="timeline-icon">
        <dvlib-icon [iconName]="icon" [tooltip]="iconTooltipText" />
    </div>
    <div class="line" [class.last]="isLast"></div>
</div>
